export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=1633375b&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/index.vue?vue&type=template&id=1633375b&scoped=true&
// module id = null
// module chunks = 